import React from 'react';
import { IFlowScreens, Task } from 'types/flows';

import TvIcon from '@mui/icons-material/Tv';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { generateScreenTask } from '@utils/flows';

interface IAddScreenButtonProps {
	onAddTasks: (
		tasks: Task[],
		e: React.MouseEvent,
		screens?: IFlowScreens
	) => void;
	width: number;
}

const AddScreenButton = ({ onAddTasks, width }: IAddScreenButtonProps) => {
	const onAddScreen = React.useCallback(
		(e: React.MouseEvent) => {
			onAddTasks(
				[generateScreenTask(intl.tr('flows.builder.task.new.screen'))],
				e
			);
		},
		[onAddTasks]
	);

	return (
		<MenuItem
			autoFocus
			onClick={onAddScreen}
			data-testid="add-screen-task"
			sx={{ width }}
		>
			<ListItemIcon>
				<TvIcon />
			</ListItemIcon>
			<Typography variant="inherit">
				{intl.tr('flows.builder.add.item.screen')}
			</Typography>
		</MenuItem>
	);
};

AddScreenButton.defaultProps = {};

export default AddScreenButton;
